import { useCallback, useEffect, useState } from 'react'

import {
  defaultOrgsDataReceiver,
  orgsFilter,
  orgsFilterSelection,
  orgTypesFilterSelection,
  defaultOrgsSelection,
} from 'app/dataProviders/filter-items'

import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import { OrgType } from 'app/dataTypes/org/types'

export const OrgsFilter = ({ id, pending }: { id: string; pending: boolean }) => {
  const [isReady, setReady] = useState(false)

  const orgTypesFilterHandler = useCallback((data: Array<OrgType>) => {
    if (data.length === 1) {
      orgsFilter.addDataReceiver(defaultOrgsDataReceiver)
      orgsFilter.dataReceive()
      orgsFilter.setStatusReady()
      setReady(true)
      return
    }
    orgsFilter.resetToDefault()
    setReady(false)
  }, [])

  useEffect(() => {
    const unsubsribeOrgType = subscibeTo<Array<OrgType>>(
      orgTypesFilterSelection.id,
      orgTypesFilterHandler,
    )
    return () => {
      unsubsribeOrgType()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isReady && (
      <PlainItemsSelectorBox
        id={id}
        label="Заведение"
        header="Выбор заведения"
        dataBoxData={orgsFilter}
        dataBoxSelection={orgsFilterSelection}
        pleaseSelectText="Нет данных"
        selectedAllOnEmptySelection
        disabled={pending}
        multiple
        defaultSelection={defaultOrgsSelection}
      />
    )
  )
}
